import { render, staticRenderFns } from "./AppVideo.vue?vue&type=template&id=61674b64&scoped=true&"
import script from "./AppVideo.vue?vue&type=script&lang=js&"
export * from "./AppVideo.vue?vue&type=script&lang=js&"
import style0 from "./AppVideo.vue?vue&type=style&index=0&id=61674b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61674b64",
  null
  
)

export default component.exports